import RequirePalmettoFinanceUser from '@/components/auth/RequirePalmettoFinanceUser';
import { RequirePayoutsAccountingSettingsUser } from '@/components/auth/RequirePayoutsAccountingSettingsUser';
import { PaymentHoldModal } from '@/components/settings/organizations/Payments/PaymentHoldModal';
import {
  useGetOrganizationPaymentSettingsQuery,
  usePutOrganizationPaymentSettingMutation,
} from '@/services/organizations';
import { OrganizationNode } from '@/types/Organizations';
import { Box, Card, FormLabel, toast, Toggle } from '@palmetto/palmetto-components';
import { useCallback, useState } from 'react';

export interface PaymentsOrgSettingProps {
  organization: OrganizationNode;
}
export const PaymentsOrgSetting = ({ organization }: PaymentsOrgSettingProps) => {
  const { data: paymentSettings } = useGetOrganizationPaymentSettingsQuery({ alias: organization.alias });
  const [updatePaymentSetting] = usePutOrganizationPaymentSettingMutation();
  const [isModalShowing, setIsModalShowing] = useState(false);
  const hideModal = useCallback(() => setIsModalShowing(false), [setIsModalShowing]);
  const handlePaymentHoldToggle = useCallback(() => {
    setIsModalShowing(true);
  }, [setIsModalShowing]);

  const updatePaymentHold = useCallback(
    async (reason: string) => {
      const payoutHold = {
        active: !paymentSettings?.payoutHold?.active,
        reason,
      };

      try {
        await updatePaymentSetting({
          alias: organization.alias,
          paymentSettings: {
            payoutHold,
          },
        }).unwrap();
        toast.success('Payment hold has been successfully updated');
      } catch (error) {
        toast.error('Failed to update payment hold');
        console.error(error);
      }
    },
    [updatePaymentSetting, organization.alias, paymentSettings],
  );

  return (
    <Card>
      <Card.Header>
        <Box as="h3" fontWeight="medium" fontSize="md">
          Organization Payment Settings
        </Box>
      </Card.Header>
      <RequirePalmettoFinanceUser>
        <RequirePayoutsAccountingSettingsUser>
          <PaymentHoldModal
            isOpen={isModalShowing}
            isPaymentHoldCurrentlyActive={paymentSettings?.payoutHold?.active ?? false}
            onDismiss={hideModal}
            onConfirm={updatePaymentHold}
          />
          <Box margin="lg">
            <Toggle
              id="paymentHold"
              isChecked={paymentSettings?.payoutHold?.active ?? false}
              label="Payment Hold"
              onChange={handlePaymentHoldToggle}
            />
            {paymentSettings?.payoutHold?.active && (
              <Box padding="md xl" direction="row" gap="sm">
                <FormLabel inputId="">Reason: </FormLabel>
                <Box>{paymentSettings?.payoutHold?.reason}</Box>
              </Box>
            )}
          </Box>
        </RequirePayoutsAccountingSettingsUser>
      </RequirePalmettoFinanceUser>
    </Card>
  );
};
